import { FilterClauseViewFragment } from 'generated/graphql';
import { isEqual } from 'lodash';
import { useMemo } from 'react';
import useGetSourceDetailsMap from 'v2/core/repository/edge-server/source-details';
import { mapToEQL } from 'v2/core/repository/eql/mappers';
import { parseEQL } from 'v2/core/repository/eql/parser';
import { ExpressionType } from 'v2/core/repository/eql/types';
import {
  EmptyWhereClause,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';
import { useGetUser } from 'v2/core/services/user';

export const useGetHasWhereClauseChanged = ({
  filterClause,
  whereClause,
}: {
  filterClause?: FilterClauseViewFragment;
  whereClause: WhereClause;
}) => {
  const {
    tenant: { timezone },
  } = useGetUser();
  const { data: sourceDetailsMap } = useGetSourceDetailsMap();

  const defaultWhereClause = useMemo(() => {
    if (!filterClause?.whereClause || !sourceDetailsMap) {
      return EmptyWhereClause;
    }

    const eqlExpression = `${mapToEQL({
      expressionType: ExpressionType.Records,
      sourceDetailsMap,
    })} where ${filterClause.whereClause}`;

    return parseEQL(eqlExpression, sourceDetailsMap, timezone).whereClause;
  }, [filterClause?.whereClause, sourceDetailsMap, timezone]);

  // This is done to remove keys with undefined values from object.
  const parsedWhereClause = JSON.parse(JSON.stringify(whereClause));
  const parsedDefaultWhereClause = JSON.parse(
    JSON.stringify(defaultWhereClause),
  );

  return !isEqual(parsedWhereClause, parsedDefaultWhereClause);
};
